// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app[data-v-4caba4d6]{background-color:rgba(233,244,246,.5)!important}", ""]);
// Exports
module.exports = exports;
